// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"862":"2b1dcf3b","2717":"2b1dcf3b","2917":"2b1dcf3b","3336":"2b1dcf3b","8735":"2b1dcf3b","8786":"2b1dcf3b"}[chunkId] + ".chunk.css";
};